
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment faire de la prospection client sur Internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les bases de la prospection client, des méthodes efficaces pour prospecter sur Internet, et les erreurs à éviter pour maximiser vos résultats.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment faire de la prospection client sur Internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Qu’est-ce que la prospection client ? Comment prospecter sur Internet ? Quelles erreurs éviter ? Cet article vous explique tout !",
        },
      ],
    };
  },
};
